<template>
  <div class="search-form__section">
    <div class="search-form__label">
      <slot name="title" />
    </div>

    <div>
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {}
</script>
